require('./expensesByCategoryFilter.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const {
    Component
} = require('react');
const moment = require('moment');

// @ commons
const OKModal = require('components/commons/OKModal/OKModal');
const DateFilter = require('components/commons/dateFilter/dateFilter');
const SubcategoryFilter = require('components/commons/subcategoryFilter/subcategoryFilter');
const GroupContractFilter = require('components/commons/groupContractFilter/groupContractFilter');
const TypeAccountFilter = require('components/commons/typeAccountFilter/typeAccountFilter');

// @ constants
const DATE_FILTER_MIN_DATE_LIMIT = moment().startOf('day').subtract(1, 'years');

class ExpensesByCategoryFilter extends Component {

    constructor(props) {
        super(props);

        const { immFilter, accounts, cards } = props;

        this.state = {
            accountsContracts: accounts,
            cardsContracts: cards,
            selected: immFilter.getIn(['date', 'selected']),
            dateFrom: immFilter.getIn(['date', 'from']),
            dateTo: immFilter.getIn(['date', 'to']),
            groupContract: immFilter.getIn(['groupContract', 'value']),
            subcategory: immFilter.getIn(['subcategory', 'subcategory']),
            typeAccount: immFilter.getIn(['typeAccount', 'value'])
        };

        this.handleFilters = this.handleFilters.bind(this);
        this.handleChangeDateMin = this.handleChangeDateMin.bind(this);
        this.handleChangeDateMax = this.handleChangeDateMax.bind(this);
        this.handleChangeDateSelected = this.handleChangeDateSelected.bind(this);
        this.handleToggleContract = this.handleToggleContract.bind(this);
        this.handleSubcategoryChange = this.handleSubcategoryChange.bind(this);
        this.handleGroupContractChange = this.handleGroupContractChange.bind(this);
        this.handleTypeAccount = this.handleTypeAccount.bind(this);
    }

    allContractsSelected(accountsContracts, cardsContracts) {
        let allSelected = true;

        accountsContracts.forEach(item => {
            allSelected = allSelected && item.selected;
        });

        cardsContracts.forEach(item => {
            allSelected = allSelected && item.selected;
        });

        return allSelected;
    }

    handleFilters() {
        const { immFilter, setFilter, onCloseClick } = this.props;
        const { accountsContracts, cardsContracts, dateFrom, dateTo, selected, subcategory, groupContract, typeAccount } = this.state;

        setFilter({
            contracts: {
                isActive: true,
                accountsContracts: accountsContracts,
                cardsContracts: cardsContracts
            },
            date: {
                isActive: selected !== 'None',
                from: dateFrom || immFilter.getIn(['date', 'from']),
                to: dateTo || immFilter.getIn(['date', 'to']),
                selected: selected || immFilter.getIn(['date', 'selected'])
            },
            subcategory: {
                isActive: subcategory !== 'all',
                subcategory
            },
            groupContract: {
                value: groupContract
            },
            typeAccount: {
                value: typeAccount
            }
        });

        onCloseClick();
    }

    handleChangeDateMin(dateFrom) {
        this.setState({
            dateFrom
        });
    }

    handleChangeDateMax(dateTo) {
        this.setState({
            dateTo
        });
    }

    handleChangeDateSelected(selected) {
        this.setState({
            selected
        });
    }

    handleTypeAccount(typeAccount) {
        this.setState({
            typeAccount
        });
    }

    handleGroupContractChange(groupContract) {
        this.setState({
            groupContract
        });

        this.handleToggleContract(groupContract);
    }

    handleToggleContract(groupContract) {
        this.setState({
            accountsContracts: groupContract === '2' || groupContract === '0' ? [...this.props.accounts.map(item => {
                return item;
            })] :[] ,
            cardsContracts: groupContract === '2' || groupContract === '1' ? [...this.props.cards.map(item => {
                return item;
            })] :[] ,
        });
    }

    handleSubcategoryChange(subcategory) {
        this.setState({
            subcategory
        });
    }

    render() {
        const {
            category,
            immFilter,
            isOpen,
            onCloseClick,
            showSubcategories
        } = this.props;
        const contentModal = (
            <section className="expenses-by-category-filter modal-container">
                <div className="col-xs-12 modal-scroll-container">
                    <DateFilter
                        immFilter={immFilter.get('date')}
                        onChangeMin={this.handleChangeDateMin}
                        onChangeMax={this.handleChangeDateMax}
                        onChangeSelected={this.handleChangeDateSelected}
                        minDate={DATE_FILTER_MIN_DATE_LIMIT}
                        showTwoYears={false}
                    />
                    <TypeAccountFilter
                        immFilter={immFilter}
                        onChangeSelected={this.handleTypeAccount}
                    />
                    <GroupContractFilter
                        immFilter={immFilter}
                        onChangeSelected={this.handleGroupContractChange}
                    />
                    {showSubcategories && <SubcategoryFilter
                        immFilter={immFilter}
                        category={category}
                        onSubcategoryChange={this.handleSubcategoryChange}
                    />}
                </div>
            </section>
        );

        return (
            <OKModal
                content={contentModal}
                footerType="navigation"
                isOpen={isOpen}
                onCloseCallback={onCloseClick}
                onPrimaryButtonClick={this.handleFilters}
                onSecondaryButtonClick={onCloseClick}
                primaryButtonText="filterDate-apply"
                secondaryButtonText="filterDate-cancel"
                size="large"
                title="accounts-filterMovements"
                titleTooltip="accountMovements-filterTooltip"
                type="filter"
            />
        )
    }
}

ExpensesByCategoryFilter.propTypes = {
    onCloseClick: PropTypes.func.isRequired,
    immFilter: PropTypes.object,
    isOpen: PropTypes.bool,
    setFilter: PropTypes.func,
    accountsContracts: PropTypes.object,
    cardsContracts: PropTypes.object,
    cards: PropTypes.array,
    accounts: PropTypes.array,
    category: PropTypes.string.isRequired,
    showSubcategories: PropTypes.bool
}

module.exports = ExpensesByCategoryFilter;
